<script>
import CommitmentModal from '@/views/components/CommitmentModal.vue'
import { setDoubleCameraDetectFinished } from '../helper/detectFinish.helper'
import { openCameraHelpLink } from '../helper/deviceDetect.helper'
import { getExamCheckInfo, startExam, checkExamIdCard } from '@/apis/exam.api'
import NoPassTipModal from '../NoPassTipModal.vue'
import successIcon from '../assets/success.svg'
import failIcon from '../assets/fail.svg'
import { mapState } from 'vuex'
import { getExamId } from '@/utils'
export default {
  data() {
    return {
      showCommitmentModal: false,
      isPass: undefined,
      isShowNoPassTip: false,
      successIcon,
      failIcon
    }
  },
  inject: ['from'],
  computed: {
    ...mapState(['testConfig']),
    testInfo() {
      return this.$store.state.testInfo
    }
  },
  components: {
    CommitmentModal,
    NoPassTipModal
  },
  props: {
    allDetectInfos: {
      type: Object,
      default: () => {
        return {
          networkAndDevices: {
            os: {
              result: '',
              isPass: false
            },
            browser: {
              result: '',
              isPass: false
            },
            browserCore: {
              result: '',
              isPass: false
            },
            network: {
              result: '',
              isPass: false
            }
          },
          camera: {
            result: '',
            isPass: false
          },
          microphone: {
            result: '',
            isPass: false
          },
          cellPhone: {
            result: '',
            isPass: false
          }
        }
      }
    },
    isOpenNetworkAndDevice: {
      type: Boolean,
      default: false
    },
    isOpenCamera: {
      type: Boolean,
      default: false
    },
    isOpenMic: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleSolveCamera() {
      openCameraHelpLink(this.allDetectInfos.camera.errorCode)
    },
    handleSolveMicrophone() {
      window.open('https://education.codemao.cn/27/contest/1/获取摄像头权限失败.pdf')
    },
    handleSolveExamEnv() {
      window.open('https://education.codemao.cn/27/contest/1/手机摄像头权限获取失败.pdf')
    },
    handleSolveBrowser() {
      window.open('https://www.google.cn/intl/zh-CN/chrome/')
    },
    handleSolveNetwork() {
      window.open('https://education.codemao.cn/207/比赛网络异常说明指引(双机位).pdf')
    },
    // 检测是否需要弹考试承诺
    async checkOpenCommitment() {
      let { exam_config } = this.$store.state.examConfig
      const examId = this.$route.query.examId || getExamId()
      localStorage.setItem('examId', examId)
      // 为了兼容从其他系统直接跳转过来拿不到数据的情况
      if (!exam_config) {
        try {
          const data = await getExamCheckInfo(examId) // 配置信息
          exam_config = data.exam_config
        } catch (e) {
          this.$router.push({ name: 'list' })
          return
        }
      }
      // 是否配置了考前承诺，1 配置，0 未配置
      const commitmentConfig = exam_config.find(
        (item) => item.label === 'LARGE_EXAM#exam_commitment'
      )
      const commitment = commitmentConfig && commitmentConfig.actual_value
      const isAgreeOfExamId = localStorage.getItem(`exam_commitment_${examId}`)
      return !!parseInt(commitment) && !isAgreeOfExamId
    },

    async goToStartExam() {
      // 如果是从候考页跳转过来的 && 考试时间到 直接开始考试
      const {
        testInfo: { exam_id, examinee_id, startExaminee },
        user: { id }
      } = this.$store.state
      if (this.from.name === 'pretest' && startExaminee) {
        if (
          this.testConfig.examType !== 3 && // 不是敏捷考试
          this.testConfig.identityVerification // 需要上传身份证
        ) {
          const examId = this.$route.query.examId || getExamId()
          const {
            has_face_info
          } = await checkExamIdCard(examId)
          // 判断是否需要身份证认证
          if (this.testConfig.identityVerification && !has_face_info) {
            this.$router.push({
              name: 'identityCheck',
              query: {
                examId
              }
            })
            return
          }
        }

        await startExam({
          examId: exam_id,
          examineeId: examinee_id
        })
        localStorage.setItem('user_id', id)
        this.$router.push({ name: 'test', query: { examId: exam_id } })
      } else {
        const examId =
          this.$route.query.examId || getExamId()
        this.$router.push({
          name: this.from.name || 'list',
          params: { fromDetect: !!examId }
        })
      }
    },

    async handelStartExamClick() {
      if (!this.isPass) {
        this.isShowNoPassTip = true
        return
      }

      const isShowCommitment = await this.checkOpenCommitment()
      if (isShowCommitment) {
        this.showCommitmentModal = true
      } else {
        this.goToStartExam()
      }
    },
    handleRestartDetect() {
      this.$emit('restart-detect')
    }
  },
  watch: {
    allDetectInfos: {
      handler(_allDetectInfos) {
        const isAllPass = Object.keys(_allDetectInfos).every((key) => {
          if (key === 'networkAndDevices' && !this.isOpenNetworkAndDevice) {
            return true
          }

          if (key === 'camera' && !this.isOpenCamera) {
            return true
          }

          if (key === 'microphone' && !this.isOpenMic) {
            return true
          }

          if (key === 'networkAndDevices') {
            return Object.keys(_allDetectInfos.networkAndDevices).every(
              (item) => {
                return _allDetectInfos.networkAndDevices[item].isPass
              }
            )
          }
          return _allDetectInfos[key].isPass
        })
        if (isAllPass) {
          this.isPass = true
          setDoubleCameraDetectFinished()
        } else {
          this.isPass = false
          setDoubleCameraDetectFinished(false)
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
<template>
  <div class="prepare-info-box">
    <div class="detect-infos">
      <div v-if="isOpenNetworkAndDevice" class="detect-infos-item">
        <div class="infos-title">网络与设备检测</div>
        <div class="infos-rows">
          <div class="infos-row">
            <p class="result-text">
              系统版本：{{ allDetectInfos.networkAndDevices.os.result }}
            </p>
            <p
              class="pass-text"
              :class="{
                'pass-fail': !allDetectInfos.networkAndDevices.os.isPass
              }"
            >
              {{ allDetectInfos.networkAndDevices.os.isPass ? '通过' : '异常' }}
            </p>
          </div>
          <div class="infos-row">
            <p class="result-text">
              浏览器：{{ allDetectInfos.networkAndDevices.browser.result }}
              <span class="pass-fail" v-if="!allDetectInfos.networkAndDevices.browser.isPass">请使用最新版本的谷歌浏览器</span>
              <span @click="handleSolveBrowser" v-if="!allDetectInfos.networkAndDevices.browser.isPass" class="solve-tips">下载</span>
            </p>
            <p
              class="pass-text"
              :class="{
                'pass-fail': !allDetectInfos.networkAndDevices.browser.isPass
              }"
            >
              {{
                allDetectInfos.networkAndDevices.browser.isPass
                  ? '通过'
                  : '异常'
              }}
            </p>
          </div>
          <div class="infos-row">
            <p class="result-text">
              浏览器内核：{{
                allDetectInfos.networkAndDevices.browserCore.result
              }}
              <span class="pass-fail" v-if="!allDetectInfos.networkAndDevices.browserCore.isPass">请使用最新版本的谷歌浏览器</span>
              <span @click="handleSolveBrowser" v-if="!allDetectInfos.networkAndDevices.browserCore.isPass" class="solve-tips">下载</span>
            </p>
            <p
              class="pass-text"
              :class="{
                'pass-fail':
                  !allDetectInfos.networkAndDevices.browserCore.isPass
              }"
            >
              {{
                allDetectInfos.networkAndDevices.browserCore.isPass
                  ? '通过'
                  : '异常'
              }}
            </p>
          </div>
          <div class="infos-row">
            <p class="result-text">
              网络：{{ allDetectInfos.networkAndDevices.network.result }}
              <span
                @click="handleSolveNetwork"
                class="solve-tips"
                v-if="!allDetectInfos.networkAndDevices.network.isPass"
              >
                解决方案
              </span>
            </p>
            <p
              class="pass-text"
              :class="{
                'pass-fail': !allDetectInfos.networkAndDevices.network.isPass
              }"
            >
              {{
                allDetectInfos.networkAndDevices.network.isPass
                  ? '通过'
                  : '异常'
              }}
            </p>
          </div>
        </div>
      </div>
      <div v-if="isOpenCamera" class="detect-infos-item">
        <div class="infos-title">摄像头检测</div>
        <div class="infos-rows">
          <div class="infos-row">
            <p class="result-text">
              <span>
                电脑摄像头<span v-if="!allDetectInfos.camera.isPass">:</span>
                <span
                  v-if="!allDetectInfos.camera.isPass"
                  :class="{
                    'pass-fail': !allDetectInfos.camera.isPass,
                    'pass-success': allDetectInfos.camera.isPass
                  }"
                >
                  {{ allDetectInfos.camera.result }}
                </span>
              </span>
              <span
                class="solve-tips"
                @click="handleSolveCamera"
                v-if="!allDetectInfos.camera.isPass"
              >
                解决方案
              </span>
            </p>
            <p
              class="pass-text"
              :class="{
                'pass-fail': !allDetectInfos.camera.isPass
              }"
            >
              {{ allDetectInfos.camera.isPass ? '通过' : '异常' }}
            </p>
          </div>
        </div>
      </div>
      <div v-if="isOpenMic" class="detect-infos-item">
        <div class="infos-title">麦克风检测</div>
        <div class="infos-rows">
          <div class="infos-row">
            <p class="result-text">
              <span>
                麦克风<span v-if="!allDetectInfos.microphone.isPass">:</span>
                <span
                  v-if="!allDetectInfos.microphone.isPass"
                  :class="{
                    'pass-fail': !allDetectInfos.microphone.isPass,
                    'pass-success': allDetectInfos.microphone.isPass
                  }"
                >
                  {{ allDetectInfos.microphone.result }}
                </span>
              </span>
              <span
                @click="handleSolveMicrophone"
                class="solve-tips"
                v-if="!allDetectInfos.microphone.isPass"
              >
                解决方案
              </span>
            </p>
            <p
              class="pass-text"
              :class="{
                'pass-fail': !allDetectInfos.microphone.isPass
              }"
            >
              {{ allDetectInfos.microphone.isPass ? '通过' : '异常' }}
            </p>
          </div>
        </div>
      </div>
      <div class="detect-infos-item">
        <div class="infos-title">考试环境</div>
        <div class="infos-rows">
          <div class="infos-row">
            <p class="result-text">
              <span>
                手机摄像头:
                <span
                  :class="{
                    'pass-fail': !allDetectInfos.cellPhone.isPass,
                    'pass-success': allDetectInfos.cellPhone.isPass
                  }"
                >
                  {{ allDetectInfos.cellPhone.result }}
                </span>
              </span>
              <span @click="handleSolveExamEnv" class="solve-tips" v-if="!allDetectInfos.cellPhone.isPass">
                解决方案
              </span>
            </p>
            <p
              class="pass-text"
              :class="{
                'pass-fail': !allDetectInfos.cellPhone.isPass
              }"
            >
              {{ allDetectInfos.cellPhone.isPass ? '通过' : '异常' }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <p
      v-if="isPass !== undefined"
      class="tips"
      :class="{
        'tips__success': isPass,
        'tips__fail': !isPass
      }"
    >
      <img :src="isPass ? successIcon : failIcon" />
      <span> {{isPass ? '当前设备没有任何问题，可以正常考试。' : '电脑设备检测不通过，可能会影响考试。'}}</span>
    </p>

    <div class="btn-wrapper">
      <button @click="handleRestartDetect" v-if="!isPass" class="btn-outline">重新检测</button>
      <button
        class="btn"
        :class="{
          'btn-single': isPass
        }"
        @click="handelStartExamClick"
      >
        {{ isPass ? '开始考试' : '已知风险，进入' }}
      </button>
    </div>
    <CommitmentModal
      v-show="showCommitmentModal"
      @close="showCommitmentModal = false"
    />
    <NoPassTipModal
      v-if="isShowNoPassTip"
      @close="isShowNoPassTip = false"
      @goTest="goToStartExam"
    />
  </div>
</template>
<style lang="scss" scoped>
.detect-infos {
  display: flex;
  flex-direction: column;
  margin: auto;
  width: fit-content;
  margin-top: 32px;
  border: 1px solid #d1d7e1;

  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 16px;
  text-align: left;
  border-radius: 4px;
}
.detect-infos-item {
  display: flex;
  border-bottom: 1px solid #d1d7e1;
}
.detect-infos-item:last-child {
  border-bottom: none;
}
.infos-title {
  width: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #d1d7e1;
}
.infos-row {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #d1d7e1;
}
.infos-row:last-child {
  border-bottom: none;
}
.result-text {
  min-width: 450px;
  height: 40px;
  padding: 10px 20px;
  border-right: 1px solid #d1d7e1;
  color: #00000073;
  line-height: 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pass-text {
  width: 96px;
  height: 40px;
  padding: 10px 30px;
  color: #389e0dff;
  line-height: 22px;
}
.pass-fail {
  color: #f5222dff;
}
.pass-success {
  color: #389e0dff;
}
.solve-tips {
  color: #2f54ebff;
  cursor: pointer;
  text-decoration: underline;
}
.solve-tips:hover {
  color: #1d39c4ff;
}
.solve-tips:active {
  color: #141d6bff;
}
.btn-wrapper {
  display: flex;
  justify-content: center;
  margin: 32px auto;
}
.btn {
  width: 184px;
  height: 48px;
  border-radius: 8px;
  padding: 12px 24px;
  border: none;
  background: linear-gradient(96deg, #329dfc 0%, #397efd 100%);
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}
.btn:hover {
  background: linear-gradient(96deg, #329dfc 0%, #397efd 100%);
  opacity: 0.8;
}
.btn:active {
  background: linear-gradient(96deg, #0d8dff 0%, #005aff 100%);
}
.btn-single {
  width: 340px;
}

.btn-outline {
  width: 184px;
  height: 48px;
  border-radius: 8px;
  padding: 12px 24px;
  border: 1px solid #155eef;
  background-color: transparent;
  color: #155eef;
  font-size: 16px;
  cursor: pointer;
  margin-right: 30px;
}
.btn-outline:hover {
  border: 1px solid #597ef7ff;
  color: #597ef7ff;
}
.btn-outline:active {
  border: 1px solid #1d39c4ff;
  color: #1d39c4ff;
}
.tips {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  width: fit-content;
  margin: 0 auto;
  margin-top: 16px;
  padding: 4px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  img {
    margin-right: 4px;
    width: 14px;
    height: 14px;
  }
}
.tips__success {
  color: #389E0D;
  background: #F6FFED;
  border: 1px solid #B7EB8F;
}
.tips__fail {
  color: #F5222D;
  background: #FFF1F0;
  border: 1px solid #FFA39E;
}
</style>
